import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Feature from '../common/Feature';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import TotalProductCount from './common/TotalProductCount';
// import OptInPopup from "../components/OptInPopup";
import config from "../../config";
import {buildEcomProductArrayForTopProducts, pushNewEcommerceEvent} from "../../utils/datalayer";
import InView from "../common/InView";

class Category extends Component {
	constructor(props) {
		super(props);
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}
	handleTopProductsInview() {
		const {featuredProduct} = this.props;
		const items = buildEcomProductArrayForTopProducts(featuredProduct, 'Portable Safes');
		pushNewEcommerceEvent('view_item_list', items);
	}
	render() {
		const pageTitle = 'Portable Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						title={ `Best Selling ${pageTitle}` }
						subTitle="Portable protection for your most valued belongings"
						path="portable-safes"
						buttonCTA={ `View all ${pageTitle}` }
						topProduct={ this.props.featuredProduct }
					/>
				</InView>
			);
		}

		return (
			<div className="category category-portable">
				<Helmet defer={false}>
					<title>{ pageTitle } &#124; SentrySafe</title>
					<meta name="description" content="Our portable safes provide on-the-go security for cash, keys, electronics and more. View portable safes." />
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/portable-safes.jpg') }
					imageAlt="Man and woman unpacking"
					title={ pageTitle }
					description="Security for life on the go."
				/>

				<TrustedSection
					content="You live life on-the-go. And wherever you go, you bring along valuable and irreplaceable items like cell phones full of photos, wallets, keys, small electronics and more. With a lightweight design and strong security features, our line of portable safes makes it easy to keep your possessions safe while in your car or truck, dorm and hotel rooms, campers, boats, and even trips to the beach."
				/>

				{ topProducts }

				<section className="row features">
					<div className="col">
						<h2 className="title">On-the-Go Security Features</h2>
					</div>
					<div className="callouts">
						<Feature
							title="Tethering Cable"
							description="A steel tethering cable allows you to attach your portable safe to a fixed object."
							image={ require('../../resources/img/features/tether-cable.png') }
						/>
						<Feature
							title="Steel Construction"
							description="For durable and reliable protection."
							image={ require('../../resources/img/features/steel-construction.png') }
						/>
						<Feature
							title="Programmable Lock"
							description="Most portable safes come with a programmable 3-digit or digital keypad for custom passcodes."
							image={ require('../../resources/img/features/digital-lock.png') }
						/>
					</div>
				</section>

				<TotalProductCount
					link="portable-safes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
				{/*<OptInPopup />*/}
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/PortableCategory.js